import { useMemo } from 'react'

type Callback = (...args: any[]) => any

const createMemo =
  <F extends Callback>(fn: F): ((...args: Parameters<F>) => ReturnType<F>) =>
  (...args) =>
    useMemo(() => fn(...args), args) // eslint-disable-line react-hooks/exhaustive-deps

export default createMemo
